import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useClerk } from "@clerk/tanstack-react-start";
import { useEffect } from "react";
import { logInfo } from "@/lib/structured-log";

interface SessionExpiredSearchParams {
  reason?: string;
}

export const Route = createFileRoute("/signin/expired")({
  component: SessionExpiredPage,
  validateSearch: (search: Record<string, unknown>): SessionExpiredSearchParams => {
    return {
      reason: typeof search.reason === "string" ? search.reason : undefined,
    };
  },
});

function SessionExpiredPage() {
  const { signOut } = useClerk();
  const navigate = useNavigate();
  const search = Route.useSearch();

  useEffect(() => {
    const handleSessionExpired = async () => {
      try {
        logInfo("auth.session_expired.signout_start", {
          reason: search.reason || "session_expired",
        });

        // Sign out from Clerk, clearing all session data
        await signOut();

        logInfo("auth.session_expired.signout_complete", {
          reason: search.reason || "session_expired",
        });

        // Redirect to signin page
        await navigate({
          to: "/signin",
          replace: true,
        });
      } catch (error) {
        // If signout fails, still redirect to signin
        logInfo("auth.session_expired.signout_error", {
          error: error instanceof Error ? error.message : "unknown-error",
        });
        await navigate({
          to: "/signin",
          replace: true,
        });
      }
    };

    handleSessionExpired();
  }, [signOut, navigate, search.reason]);

  // 不显示任何UI,直接执行signout逻辑
  // 这个过程应该很快,用户不会看到这个页面
  return null;
}
